<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pagePolicies.title') }}
    </portal>
    <template v-if="policies !== null">
      <card :title="$t('admin.pagePolicies.card.policies')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="policy in policies" v-if="!policy.deleted">
              <hm-card-inner-line :title="getName(policy)" :clickable="true" :key="policy.id" @click="routeToPolicy(policy)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedPolicies)" :title="$t('admin.pagePolicies.card.deletedPolicies')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="policy in deletedPolicies"
                              :title="getName(policy)"
                              :clickable="true"
                              :key="policy.id"
                              @click="routeToPolicy(policy)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pagePolicies.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pagePolicies.actions.addPolicy')" icon="plus" color="blue" @click="addPolicy()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';

export default {
  name: 'PagePolicies',

  components: {
    draggable,
  },

  mixins: [HotelmeisterMixin],

  data() {
    return {
      policies: null,
    };
  },

  computed: {
    deletedPolicies: function () {
      return isNil(this.policies) ? null : this.policies.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.policy.list(this))
        .then((response) => {
          this.policies = response.data.data;

          this.$serviceBus.$emit('policy.list', this.policies);
        });
    },
    addPolicy() {
      this.axios.post(this.serviceUrls.policy.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pagePolicies.newPolicyName'),
        },
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(policy) {
      const name = isNil(policy) ? null : policy.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name;

      const details = '';

      if (policy.deleted === false) {
        // if (!isNil(policy.amount) && policy.amount !== 0) {
        //   details += `, ${policy.amount.toLocaleString(this.$i18n.locale, {
        //     minimumFractionDigits: 2,
        //     maximumFractionDigits: 2,
        //   })} ${policy.percentage === true ? '%' : this.hotelSettings.details.currency}`;
        // }
        //
        // if (policy.rateMode === 'PerPerson') {
        //   details += ` ${this.$t('RateMode.PerPerson')}`;
        // }
        //
        // if (policy.rateFrequency === 'PerNight') {
        //   details += ` ${this.$t('RateFrequency.PerNight')}`;
        // }
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToPolicy(policy) {
      this.$router.push({
        name: 'policy',
        params: {
          policyId: policy.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PagePolicies.vue